import { graphql } from "gatsby"
import React from "react"

import CoreImage from "@atoms/CoreImage/CoreImage"

const CoreImageBlock = ({
  captionText,
  className,
  image,
  href,
  linkTarget = "",
}) => {
  return (
    <CoreImage
      image={image}
      caption={captionText}
      variant={className ? className.replace("is-style-", "") : null}
      href={href}
      linkTarget={linkTarget}
    />
  )
}

export const query = graphql`
  fragment CoreImage on WpBlockCoreImage {
    __typename
    captionText
    className
    href
    linkTarget
    image {
      mediaDetails {
        height
        width
      }
      cloudinaryDetails {
        format
        original_filename
        public_id
      }
      sourceUrl
      altText
      altTextOriginal
    }
  }
`

export default CoreImageBlock
